import { render, staticRenderFns } from "./MotpInput.vue?vue&type=template&id=024d8b28"
import script from "./MotpInput.vue?vue&type=script&lang=js"
export * from "./MotpInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024d8b28')) {
      api.createRecord('024d8b28', component.options)
    } else {
      api.reload('024d8b28', component.options)
    }
    module.hot.accept("./MotpInput.vue?vue&type=template&id=024d8b28", function () {
      api.rerender('024d8b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/MotpInput.vue"
export default component.exports